export default __webpack_public_path__ + "static/enceinte5-cfc04926db71cc625f9400a93fb550d3.jpg";